import React, { FC } from 'react'

import styled from 'styled-components'

import {
  compose,
  system,
  color,
  space,
  layout,
  flexbox,
  border,
  shadow,
  typography,
  position,
} from 'styled-system'

import { SystemProps } from '../../new/theme'
import { css } from '../../styled-components'

type Props = SystemProps & React.ButtonHTMLAttributes<any>

const Button: FC<Props> = styled.button<Props>(
  compose(layout, space, color, flexbox, border, shadow, typography, position),
  system({
    opacity: {
      property: 'opacity',
      scale: 'opacities',
    },
    textDecoration: {
      property: 'textDecoration',
    },
  }),
  system({
    w: {
      property: 'width',
      scale: 'sizes',
    },
  }),
  system({
    h: {
      property: 'height',
      scale: 'sizes',
    },
  }),
  system({
    textDecorationColor: {
      property: 'textDecorationColor',
      scale: 'colors',
    },
  }),
  system({
    bg: {
      property: 'background',
      scale: 'colors',
    },
  }),
  system({
    cursor: {
      property: 'cursor',
    },
  })
)

export const ButtonStyled = styled(Button)<{ disabled?: boolean }>`
  border: none;
  transition: 0.2s;

  :disabled {
    ${({ bg }) =>
      bg !== 'transparent' &&
      css`
        background-color: ${props => props.theme.colors['bg/disabled']};
        box-shadow: none;
      `}
  }

  :hover:not(:disabled) {
    opacity: ${props => props.theme.opacities['80']};
  }
`
